module.exports = __webpack_public_path__ + "img/job-banner.208f11cb.jpg";